import { Button, Tooltip, LockButton, Intent } from "@focus/focusUI";
import * as React from "react";
export const LockNSaveListButtons = ({ onLockClick, hideLockButton, onSaveClick, disableSaveButton, lockStatus, hasInitialValues = true, containerStyle, leftButtonStyle, rightButtonStyle, }) => {
    const lockButtonText = lockStatus
        ? "Click to canel panel form edition (or click alt + l)"
        : "Click to edit panel form (or click alt + l)";
    return (React.createElement("div", { style: containerStyle },
        !hideLockButton ? (React.createElement("div", { style: leftButtonStyle },
            React.createElement(Tooltip, { content: lockButtonText, usePortal: false },
                React.createElement(LockButton, { locked: lockStatus, onClick: onLockClick, hasInitialValues: hasInitialValues, showIcon: false })))) : null,
        React.createElement("div", { style: rightButtonStyle },
            React.createElement(Tooltip, { content: "Click to close and save", usePortal: false },
                React.createElement(Button, { disabled: disableSaveButton, intent: Intent.SUCCESS, onClick: onSaveClick, id: "saveCloseButton", role: "listSaveButton" }, "OK")))));
};
//# sourceMappingURL=LockNSaveListButtons.js.map